<template>
	<span v-if="visible" :class="clazz" :style="style">{{ listItemName }}</span>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {computed} from "vue";
import {injectEnv} from "../Environment";
import type {PanelDescriptor} from "../Types";
import type {Text} from "@t/fd/fixed/Text";
import type {Select} from "@t/fd/editor/Select.ts";

const uprops = defineProps({
	...editorProps
});
const props = uprops as EditorProps;
const env = injectEnv();
const {value, listItems, visible, clazz, style} = useEditor(props);

const listItemName = computed(() => {
	let varr = value.value;
	if (varr === null || typeof varr === "undefined") return "";
	if (!Array.isArray(varr)) varr = [varr];
	const names = [];
	for (let v of varr) {
		let found = false;
		for (let li of listItems.value) {
			if (li.value === v) {
				names.push(li.name);
				found = true;
				break;
			}
		}
		if (!found) names.push("(" + v + ")");
	}
	return names.join(", ");
});


function invokePicker(labelPart: Text) {
	const pg: PanelDescriptor = {
		component: "list-select-page",
		bind: {
			list: listItems.value,
			selected: value.value,
			multi: false,
			pageTitle: labelPart.value,
		}
	};
	env.showPanel(pg)
		.then((returned) => {
			if (returned !== undefined) value.value = returned;
		});
}

defineExpose({
	invokePicker
});

</script>

<style></style>
